import { DefaultTheme } from '../../components/theme';
import { ColorPalette2022Branding } from '../../components/theme.palette';

export const CSS = {
	container: 'c-AuthComponent__container',
	card: 'c-AuthComponent__Card',
	button: 'c-AuthComponent__action',
	padding: 'c-AuthComponent__spacing',
	centered: 'c-AuthComponent__centered',
	link: 'c-AuthComponent__link',
	text: 'c-AuthComponent__text',
	textInner: 'c-AuthComponent__textInner',
};

export const Style = {
	[CSS.padding]: {
		paddingTop: DefaultTheme.space(6),
	},

	[CSS.button]: {
		width: '100%',
		backgroundColor: ColorPalette2022Branding.darkGray,
		color: DefaultTheme.background.offWhite,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},

	[`${CSS.button}:hover`]: {
		backgroundColor: ColorPalette2022Branding.g3,
	},

	[CSS.container]: {
		width: '100%',
		textAlign: 'center',
		display: 'flex',
		flexDirection: 'column',
		fontSize: '14px',
	},

	[CSS.centered]: {
		transform: 'translateX(50vw) translateY(50vh)',
		marginLeft: '-12px',
		marginTop: '-12px',
	},

	[CSS.link]: {
		color: ColorPalette2022Branding.lightBlue,
		fontSize: '14px',
	},

	[`${CSS.link}:hover`]: {
		textDecoration: 'underline',
	},

	[CSS.text]: {
		color: ColorPalette2022Branding.g6,
		textAlign: 'center',
		textTransform: 'uppercase',
		fontSize: '14px',
		borderTop: `1px solid ${ColorPalette2022Branding.g6}`,
	},

	[CSS.textInner]: {
		background: DefaultTheme.background.offWhite,
		margin: 'auto',
		transform: 'translateY(-50%)',
		display: 'inline-block',
		padding: DefaultTheme.space(1),
	},
};
